var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c(
        "el-row",
        { staticClass: "margin-bottom" },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("h1", { staticClass: "titulo-pagina" }, [
              _vm._v("Upload de Planta")
            ]),
            _c("p", { staticClass: "descricao-pagina" }, [
              _vm._v(
                "Faça upload de arquivos ZIP contendo plantas PDF para processamento automático (máximo 500MB)"
              )
            ])
          ])
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "margin-bottom" },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-card",
                [
                  _c(
                    "div",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("span", [_vm._v("Fazer Upload")]),
                      _vm.showListagem
                        ? _c(
                            "el-button",
                            {
                              staticClass: "float-right",
                              attrs: { size: "small" },
                              on: {
                                click: function($event) {
                                  _vm.showListagem = false
                                }
                              }
                            },
                            [_vm._v("Fazer Novo Upload")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c("el-row", [
                    !_vm.showListagem
                      ? _c(
                          "div",
                          { staticClass: "upload-area-wrapper" },
                          [
                            _c("app-upload-area", {
                              attrs: {
                                id: "upload-planta",
                                fileType: ["zip"],
                                target: _vm.urlUpload,
                                hasDownloadButton: false,
                                maxSize: 524288000,
                                onSuccess: _vm.onUploadSuccess,
                                onError: _vm.onUploadError,
                                onProgress: _vm.onUploadProgress
                              },
                              on: { removerDocumento: _vm.removerDocumento }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _c(
                    "el-row",
                    { staticClass: "container-assinatura" },
                    [
                      !_vm.showListagem
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-text": "Inserir assinatura na planta"
                                },
                                model: {
                                  value: _vm.inserirAssinatura,
                                  callback: function($$v) {
                                    _vm.inserirAssinatura = $$v
                                  },
                                  expression: "inserirAssinatura"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.uploadProgress > 0 &&
                  _vm.uploadProgress < 100 &&
                  !_vm.showListagem
                    ? _c(
                        "el-row",
                        { staticClass: "margin-top" },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c("el-progress", {
                                attrs: {
                                  percentage: _vm.uploadProgress,
                                  "text-inside": true,
                                  "stroke-width": 20
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.uploadKey && !_vm.showListagem
                    ? _c(
                        "el-row",
                        { staticClass: "margin-top" },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c("el-alert", {
                                attrs: {
                                  title: "Arquivo carregado com sucesso!",
                                  description:
                                    "Clique no botão abaixo para processar o arquivo ZIP e extrair os dados das plantas PDF.",
                                  type: "success",
                                  "show-icon": "show-icon",
                                  closable: false
                                }
                              }),
                              _c("br"),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.processando,
                                    size: "large"
                                  },
                                  on: { click: _vm.processarArquivo }
                                },
                                [_vm._v("Processar Arquivo ZIP")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.resultadoProcessamento && !_vm.showListagem
        ? _c(
            "el-row",
            { staticClass: "margin-bottom" },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-card",
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("span", [_vm._v("Resultado do Processamento")])
                      ]),
                      _vm.resultadoProcessamento.sucesso
                        ? _c("el-alert", {
                            attrs: {
                              title: "Processamento Concluído",
                              description:
                                _vm.resultadoProcessamento.totalProcessados +
                                " arquivo(s) processado(s) com sucesso",
                              type: "success",
                              "show-icon": "show-icon"
                            }
                          })
                        : _c("el-alert", {
                            attrs: {
                              title: "Erro no Processamento",
                              description: _vm.resultadoProcessamento.mensagem,
                              type: "error",
                              "show-icon": "show-icon"
                            }
                          }),
                      _vm.resultadoProcessamento.sucesso
                        ? _c(
                            "el-row",
                            { staticClass: "margin-top" },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.verListagem }
                                    },
                                    [_vm._v("Ver Arquivos Processados")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.showListagem
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-card",
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("span", [_vm._v("Arquivos Processados")]),
                        _c(
                          "div",
                          { staticClass: "float-right" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: { click: _vm.voltarUpload }
                              },
                              [_vm._v("Voltar ao Upload")]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "div",
                        { staticClass: "filter-row" },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 5 } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "Filtrar por quadra",
                                      clearable: "clearable"
                                    },
                                    model: {
                                      value: _vm.filtros.quadra,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filtros, "quadra", $$v)
                                      },
                                      expression: "filtros.quadra"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 5 } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "Filtrar por lote",
                                      clearable: "clearable"
                                    },
                                    model: {
                                      value: _vm.filtros.lote,
                                      callback: function($$v) {
                                        _vm.$set(_vm.filtros, "lote", $$v)
                                      },
                                      expression: "filtros.lote"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "Filtrar por bairro",
                                      clearable: "clearable"
                                    },
                                    model: {
                                      value: _vm.filtros.empreendimento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.filtros,
                                          "empreendimento",
                                          $$v
                                        )
                                      },
                                      expression: "filtros.empreendimento"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 3 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { type: "primary" },
                                      on: { click: _vm.buscarRegistros }
                                    },
                                    [_vm._v("Filtrar")]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 3 } },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { width: "100%" },
                                      on: { click: _vm.limparFiltros }
                                    },
                                    [_vm._v("Limpar")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.carregandoListagem,
                              expression: "carregandoListagem"
                            }
                          ],
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.registros.content || [] }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "nomeArquivo",
                              label: "Arquivo",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "municipio",
                              label: "Município",
                              "min-width": "150"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "empreendimento",
                              label: "Bairro",
                              "min-width": "200"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "quadra",
                              label: "Quadra",
                              width: "80"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "lote", label: "Lote", width: "80" }
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "area", label: "Área", width: "100" }
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "vinculado",
                              label: "Status",
                              width: "100"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: scope.row.vinculado
                                              ? "success"
                                              : "info"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.vinculado
                                                ? "Vinculado"
                                                : "Pendente"
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              523931649
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "dataUpload",
                              label: "Data Upload",
                              width: "120"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatarData(scope.row.dataUpload)
                                        )
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3626045903
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "dataVinculacao",
                              label: "Data Vinculação",
                              width: "120"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatarData(
                                            scope.row.dataVinculacao
                                          )
                                        )
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3340419115
                            )
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Ações", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      !scope.row.vinculado &&
                                      scope.row.tipo !== "PLANTA"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.vincularProcesso(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("Vincular")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2860336206
                            )
                          })
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.currentPage,
                          "page-size": _vm.pageSize,
                          total: _vm.registros.totalElements || 0,
                          layout: "prev, pager, next, sizes, total"
                        },
                        on: {
                          "current-change": _vm.handleCurrentChange,
                          "size-change": _vm.handleSizeChange
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "vincular-modal",
          attrs: {
            title: "Vincular ao Processo",
            visible: _vm.dialogVincular,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVincular = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.vincularForm, "label-width": "160px" } },
            [
              _c("el-form-item", { attrs: { label: "Arquivo:" } }, [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.vincularForm.registro
                        ? _vm.vincularForm.registro.nomeArquivo
                        : ""
                    )
                  )
                ])
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Número do Processo:" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        "Digite o número do processo (ex: RO202500001234)"
                    },
                    model: {
                      value: _vm.vincularForm.numeroProcesso,
                      callback: function($$v) {
                        _vm.$set(_vm.vincularForm, "numeroProcesso", $$v)
                      },
                      expression: "vincularForm.numeroProcesso"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVincular = false
                    }
                  }
                },
                [_vm._v("Cancelar")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmarVinculacao }
                },
                [_vm._v("Confirmar")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bb66566", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bb66566","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/UploadPlanta.vue
// module id = null
// module chunks = 